var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 5.59664H6.16667C5.24619 5.59664 4.5 6.34283 4.5 7.26331V18.93C4.5 19.8504 5.24619 20.5966 6.16667 20.5966H17.8333C18.7538 20.5966 19.5 19.8504 19.5 18.93V7.26331C19.5 6.34283 18.7538 5.59664 17.8333 5.59664Z",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 3.92997V7.2633",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 3.92997V7.2633",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5966H19.5",
    stroke: "#587E85",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7197 13.483L11.25 15.9526L10.2803 14.9829C9.98744 14.6901 9.51255 14.6901 9.21967 14.9829C8.92678 15.2758 8.92678 15.7507 9.21967 16.0436L10.7197 17.5436C11.0126 17.8365 11.4875 17.8365 11.7803 17.5436L14.7803 14.5436C15.0732 14.2507 15.0732 13.7759 14.7803 13.483C14.4874 13.1901 14.0126 13.1901 13.7197 13.483Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoApprove);
export default __webpack_public_path__ + "static/media/auto-approve.ef2d891209857824a8e14bd57936a3ce.svg";
export { ForwardRef as ReactComponent };